import { type AllergenOrDietaryRestriction } from '../../../utils/dietary-preferences';
import { type DietaryPreferencesTypes } from '../setup/types';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasUnsavedPreferences(
  preferences: DietaryPreferencesTypes,
  pendingPreferences: DietaryPreferencesTypes,
) {
  const preferenceEntries = Object.entries(preferences);
  const checkIfValuesAreDifferent = checkIfValuesAreDifferentFactory(pendingPreferences); // prettier-ignore

  return preferenceEntries.some(checkIfValuesAreDifferent);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfValuesAreDifferentFactory(pendingPreferences: DietaryPreferencesTypes) {
  return function (preferenceEntry: PreferenceEntry) {
    const [kind, value] = preferenceEntry;
    const castedKind = kind as AllergenOrDietaryRestriction;

    return pendingPreferences[castedKind] !== value;
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type PreferenceEntry = [string, boolean];
